import axios from 'axios'

// config
import baseUrl from '../config'

export const createSideHustle = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/ace/side-hustles`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const createTrainingRecord = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/ace/training-records`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const createTrainingTemplate = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/ace/training-templates`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const bulkAssignTrainingTemplate = async ({ trainingTemplateId, participantIds }) => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/ace/training-templates/${trainingTemplateId}/assign`,
    data: { participantIds }
  })
}

export const fetchTrainingTemplate = async id => {
  const response = await axios.get(`${baseUrl}/ace/training-templates/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const updateTrainingTemplate = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/ace/training-templates/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const deleteTrainingTemplate = async ({ trainingTemplateId }) => {
  return await axios.delete(`${baseUrl}/ace/training-templates/${trainingTemplateId}`, {
    withCredentials: true
  })
}

export const createWorkRecord = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/ace/work-records`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const deleteSideHustle = async ({ sideHustleId }) => {
  return await axios.delete(`${baseUrl}/ace/side-hustles/${sideHustleId}`, {
    withCredentials: true
  })
}

export const deleteTrainingRecord = async ({ recordId }) => {
  return await axios.delete(`${baseUrl}/ace/training-records/${recordId}`, {
    withCredentials: true
  })
}

export const deleteWorkRecord = async ({ recordId }) => {
  return await axios.delete(`${baseUrl}/ace/work-records/${recordId}`, {
    withCredentials: true
  })
}

export const fetchSideHustle = async id => {
  const response = await axios.get(`${baseUrl}/ace/side-hustles/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchSideHustles = async params => {
  const response = await axios.get(`${baseUrl}/ace/side-hustles`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchTrainingTemplates = async params => {
  const response = await axios.get(`${baseUrl}/ace/training-templates`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchTrainingRecord = async id => {
  const response = await axios.get(`${baseUrl}/ace/training-records/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchTrainingRecords = async params => {
  const response = await axios.get(`${baseUrl}/ace/training-records`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const searchAceSkills = async params => {
  const response = await axios.get(`${baseUrl}/ace/training-skills/search`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchWorkRecord = async id => {
  const response = await axios.get(`${baseUrl}/ace/work-records/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchWorkRecords = async params => {
  const response = await axios.get(`${baseUrl}/ace/work-records`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const updateSideHustle = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/ace/side-hustles/${data.get('uuid')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const updateTrainingRecord = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/ace/training-records/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const updateWorkRecord = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/ace/work-records/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}
